export default __webpack_public_path__ + "static/media/add-students.aaac31a9.svg";